import { isEmpty, isNil } from 'lodash';
import { useEffect } from 'react';
import { Button } from '@shared/components/Button';
import { Menu, Submenu, useRootMenuContext } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { useCardExport } from '@shared/scenes/cards/details/hooks/CardExport';
import { i18n } from '@shared/util/i18n';

interface Props {
  entityId: string;
}

export function CardExportSubmenu({ entityId }: Props) {
  const { align } = useRootMenuContext();
  return (
    <Submenu align={align}>
      <Submenu.Trigger>
        <Menu.Item label={i18n('common.download')} />
      </Submenu.Trigger>
      <Submenu.Content>
        <CardExportContent entityId={entityId} />
      </Submenu.Content>
    </Submenu>
  );
}

function CardExportContent({ entityId }: Props) {
  const { response, createCardExport } = useCardExport();
  const rootMenu = useRootMenuContext();

  useEffect(() => {
    if (!response.isLoading && !isNil(response.url)) {
      window.open(response.url, 'coast-pdf-' + response.url);
      rootMenu?.close();
    }
  }, [response.isLoading, response.url, rootMenu]);

  const showButton = isEmpty(response.error);
  const showError = !response.isLoading && !isEmpty(response.error);

  return (
    <Menu.Section>
      {showButton && (
        <View gap={2}>
          <Text size="body2">{i18n('card.actions.share.export.pdf.description')}</Text>
          <Button
            variant="primary"
            size="jumbo"
            label={i18n('common.download')}
            onClick={() => createCardExport(entityId)}
            testID="card-export-button"
          />
        </View>
      )}
      {showError && (
        <View gap={2}>
          <Text size="body2" danger>
            {i18n('errors.somethingWentWrong')}
          </Text>
          <Button
            variant="primary"
            size="jumbo"
            label={i18n('common.retry')}
            onClick={() => createCardExport(entityId)}
          />
        </View>
      )}
    </Menu.Section>
  );
}
